import React, { useState, useEffect, useRef } from 'react';
import { uploadFile } from 'react-s3';
// import { useHistory } from 'react-router-dom';
import axios from 'axios';
import uuid from 'react-uuid';
import { Form, Button, ToggleButton, ButtonGroup } from 'react-bootstrap';
import { If, Then, Else  } from 'react-if';
import { Facebook } from 'react-spinners-css';
import canvasIntro from '../assets/drake-wide.png';
import WebCarousel from './WebCarousel';
import Carousel from './Carousel';
import '../style/meme-creator.css';
window.Buffer = window.Buffer || require("buffer").Buffer;


const Canvas = props => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    let img = new Image();
    img.src = canvasIntro;
    img.crossOrigin="anonymous";
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;

      ctx.drawImage(img, 0, 0);
    }
  }, [])

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // ctx.clearRect(0, 0, canvas.width, canvas.height);

    let img = new Image();
    img.src = props.imageFile;
    img.crossOrigin="anonymous";
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

      ctx.drawImage(img, 0, 0);

      ctx.font = `${props.textSize}px Impact`;
      ctx.fillStyle = props.textColor;
      ctx.textAlign = 'center';
      ctx.fillText(props.upperText, canvas.width / 2, 30 - (30-props.textSize));
      ctx.strokeText(props.upperText, canvas.width / 2, 30 -(30-props.textSize));

      ctx.fillText(props.lowerText, canvas.width / 2, canvas.height - 10);
      ctx.strokeText(props.lowerText, canvas.width / 2, canvas.height - 10);
    }
  })
  
  return <canvas ref={canvasRef} {...props} id='canvas-meme-creator' />
}

const ToggleColors = ({setTextColor}) => {
  const [radioValue, setRadioValue] = useState('1');

  useEffect(() => {
    switch(radioValue) {
      case '1':
        setTextColor("white");
        break;
      case '2':
        setTextColor("black");
        break;
      case '3':
        setTextColor("#FF6700");
        break;
      case '4':
        setTextColor("#C4ED74");
        break;
      case '5':
        setTextColor("#F2B5F7");
        break;
      default:
        setTextColor("white");
    }
  },[radioValue]);

  const radios = [
    { value: '1' },
    { value: '2' },
    { value: '3' },
    { value: '4' },
    { value: '5' },
  ];

  return (
      <ButtonGroup>
      {radios.map((radio, idx) => (
          <ToggleButton
              key={idx}
              id={radioValue === radio.value ? `radio-${idx + 1}-checked` : `radio-${idx + 1}`}
              type="radio"
              name="radio"
              value={radio.value}
              checked={radioValue === radio.value}
              onChange={(e) => setRadioValue(e.currentTarget.value)}
          >
              {<span style={{ width:"100%", height:"100%" }} id={radioValue === radio.value ? `radio-${idx + 1}-checked` : `radio-${idx + 1}`}>&nbsp;</span>}
          </ToggleButton>
      ))}
      </ButtonGroup>
  )
}

const MemeCreator = (props) => {
  const [textSize, setTextSize] = useState('34');
  const [upperText, setUpperText] = useState('');
  const [lowerText, setLowerText] = useState('');
  const [imageFile, setImageFile] = useState();
  const [textColor, setTextColor] = useState("white");
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakPoint = 540;
  
  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    
    return () => window.removeEventListener("resize", handleWindowResize);
  },[]);
  
  const [isUploading, setIsUploading] = useState(false);
  const handleSubmit = (e) => {
    
    e.preventDefault();
    setIsUploading(true);

    const canvas = document.getElementById('canvas-meme-creator');

    const dataURL = canvas.toDataURL();
    const blobBin = atob(dataURL.split(',')[1]);
    const array = [];
    for(var i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i));
    }
    const blob = new Blob([new Uint8Array(array)], {type: 'image/png'});
    const blobToFile = (theBlob) => {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = `${uuid()}.png`;
      return theBlob;
    }
    const image = blobToFile(blob);

    const ACCESS_KEY=process.env.REACT_APP_AWS_KEY;
    const SECRET_ACCESS_KEY=process.env.REACT_APP_SECRET;
    const S3_BUCKET=process.env.REACT_APP_BUCKET;
    const REGION=process.env.REACT_APP_REGION;
    
    const config = {
      bucketName: S3_BUCKET,
      region: REGION,
      accessKeyId: ACCESS_KEY,
      secretAccessKey: SECRET_ACCESS_KEY,
    }

    const server = process.env.REACT_APP_SERVER;

    uploadFile(image, config)
      .then(data => {
        const axiosConfig = {
          headers: { Authorization: `Bearer ${props.token}` }
        };
        axios.post(`${server}/meme`, { uploaderId: props.userId, username: props.username, imageUrl: data.location }, axiosConfig)
          .then((response) => {
            setIsUploading(false);
            alert("successfully uploaded");
          }).catch((err) => {
            console.error(err.message);
          });
      })
      .catch(err => console.error(err))
  }

  return (
    <div>
      <div id='canvas-form-wrapper' style={{"margin-top": "20px", "margin-bottom": "30px"}}>
       <div id = "meme-inputs-container">
          <Canvas 
            upperText={upperText}
            lowerText={lowerText}
            imageFile={imageFile}
            textSize={textSize}
            textColor={textColor}
          />
       
        <div id = "forms-container">
        <If condition={isUploading}>
                <Then>
                    <div id='upload-title' className='upload-spacing'>Sick meme, posse! This may take a moment...</div>
                    <div className='loading'>
                        <Facebook color="#66FCF1" />
                    </div> 
                </Then>
                <Else>
                  <Form onSubmit={handleSubmit}>          
                    <Form.Group controlId="upperText">
                      <Form.Label style = {{color: '#EFE3DA', margin: "10px"}}>Upper Text</Form.Label>
                      <Form.Control type="text" onChange={(e) => setUpperText(e.target.value)}/>
                    </Form.Group>

                    <Form.Group controlId="lowerText">
                      <Form.Label style = {{color: '#EFE3DA', margin: "10px"}}>Lower Text</Form.Label>
                      <Form.Control type="text" onChange={(e) => setLowerText(e.target.value)}/>
                    </Form.Group>
                    <Form.Group controlId="formBasicRangeCustom">
                    <Form.Label style = {{color: '#EFE3DA', margin: "10px"}}>Font Size</Form.Label>
                      <Form.Control style = {{display: "block", padding:"4px"}} type="range" min="0" max="75" onChange={(e) => setTextSize(e.target.value)}/>
                    </Form.Group>
                    <Form.Group>
                    <Form.Label style = {{color: '#EFE3DA', margin: "10px"}}>Text Color</Form.Label>
                      <div style={{padding:"10px"}}>
                        <ToggleColors setTextColor={setTextColor}/>                    
                      </div>
                    </Form.Group>
                    <input
                      type="file"
                      onChange={(e) => {setImageFile(URL.createObjectURL(e.target.files[0]))}}
                      className='custom-file-input'
                    />
                    <Button variant="primary" type="submit">Save</Button>
                  </Form>
                </Else>
                </If>
        </div>
        </div>
      </div>
      <div style={{"height":"30px"}}>
        <span>&nbsp;</span>
      </div> 
      {width > breakPoint? (
        <div style={{margin: "30px"}}>
          <WebCarousel setImageFile={setImageFile}/>
        </div>
      ) : (
        <Carousel setImageFile={setImageFile}/>
      )}
      <div style={{"height":"30px"}}>
        <span>&nbsp;</span>
      </div> 
    </div>
  );
}

export default MemeCreator;

/////////////// Resources ///////////////
// https://www.w3schools.com/graphics/canvas_text.asp
// https://github.com/AvanthikaMeenakshi/ReactMemeMaker/blob/master/src/Components/MainPage/index.js
// https://medium.com/@pdx.lucasm/canvas-with-react-js-32e133c05258
// https://github.com/GeekLaunch/meme-generator/blob/master/meme-generator.js
// https://www.freecodecamp.org/news/react-for-beginners-building-a-meme-maker-with-react-7164d3d3e55f/
// https://codepen.io/ninivert/pen/BpLKRx
/////////////////////////////////////////

